import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const DebugPanel = ({ debugData }) => {
  const [activeTab, setActiveTab] = useState("achievements");
  const [isExpanded, setIsExpanded] = useState(false);

  const tabs = [
    { id: "achievements", label: "Achievements", icon: "Award" },
    { id: "certifications", label: "Certifications", icon: "Shield" },
    { id: "metrics", label: "Metrics", icon: "BarChart3" },
  ];

  const renderAchievements = () => (
    <div className="space-y-4">
      {debugData?.achievements?.map((achievement, index) => (
        <div
          key={index}
          className="p-4 bg-success/5 border border-success/20 rounded-lg"
        >
          <div className="flex items-start space-x-3">
            <div className="w-4 sm:w-8 h-8 bg-success/20 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Trophy" size={16} className="text-success" />
            </div>
            <div className="flex-1">
              <h4 className="font-medium text-foreground mb-1">
                {achievement?.title}
              </h4>
              <p className="text-sm text-muted-foreground mb-2">
                {achievement?.description}
              </p>
              <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                <span>{achievement?.date}</span>
                <span>Impact: {achievement?.impact}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const renderCertifications = () => (
    <div className="space-y-4">
      <div className="p-4 bg-warning/5 border border-warning/20 rounded-lg text-sm font-source">
        <div className="flex items-center space-x-2 text-warning mb-1">
          <Icon name="AlertCircle" size={16} />
          <span className="font-semibold">Certification Status: 404 Not Found</span>
        </div>
        <p className="text-muted-foreground">
          I don't actually have any official certifications yet (who has time for exam prep when things are breaking in production?), but here are the ones I've earned in spirit:
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {debugData?.certifications?.map((cert, index) => (
          <div
            key={index}
            className="p-4 bg-primary/5 border border-primary/20 rounded-lg"
          >
            <div className="flex items-center space-x-3 mb-3">
              <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
                <Icon name="Award" size={20} className="text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-foreground">{cert?.name}</h4>
                <p className="text-sm text-muted-foreground">{cert?.issuer}</p>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>Issued: {cert?.date}</span>
              <span className="text-success">Valid</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderMetrics = () => (
    <div className="grid gap-4 md:grid-cols-3">
      {debugData?.metrics?.map((metric, index) => (
        <div
          key={index}
          className="p-4 bg-card border border-border rounded-lg text-center"
        >
          <div className="text-2xl font-bold text-primary mb-1">
            {metric?.value}
          </div>
          <div className="text-sm text-muted-foreground mb-2">
            {metric?.label}
          </div>
          <div className="flex items-center justify-center space-x-1 text-xs text-success">
            <Icon name="TrendingUp" size={12} />
            <span>{metric?.trend}</span>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      
      <div className="bg-muted/30 px-4 py-3 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Bug" size={16} className="text-warning" />
            <span className="font-medium text-foreground">Debug Panel</span>
            <div className="px-2 py-1 bg-warning/20 text-warning text-xs rounded font-source">
              REAL DATA
            </div>
          </div>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={16} />
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="p-4 w-[320px] sm:w-full overflow-x-auto">
          <div className="flex flex-col sm:flex-row space-x-1 mb-6 bg-muted/20 p-1 rounded-lg">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors flex-1 justify-center ${
                  activeTab === tab?.id
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:text-foreground"
                }`}
              >
                <Icon name={tab?.icon} size={16} />
                <span>{tab?.label}</span>
              </button>
            ))}
          </div>

          <div className="min-h-[300px]">
            {activeTab === "achievements" && renderAchievements()}
            {activeTab === "certifications" && renderCertifications()}
            {activeTab === "metrics" && renderMetrics()}
          </div>
        </div>
      )}
    </div>
  );
};

export default DebugPanel;
